// cache.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CacheService {
	private cache = new Map<string, any>();
	private requestCache = new Map<string, any>();

	cacheData(cacheKey: string, data: any, params: any = null): void {
		const cacheEntry = {
			data,
			params,
			timestamp: Date.now(),
			expiry: Date.now() + (5 * 60 * 1000) // 5分鐘緩存
		};
		this.cache.set(cacheKey, cacheEntry);
	}

	getCachedData(cacheKey: string): any {
		const entry = this.cache.get(cacheKey);
		if (entry && entry.expiry > Date.now()) {
			return entry.data;
		}
		this.cache.delete(cacheKey);
		return null;
	}

	cacheRequest(requestKey: string, request: any): void {
		this.requestCache.set(requestKey, {
			request,
			timestamp: Date.now()
		});
	}

	getCachedRequest(requestKey: string): any {
		return this.requestCache.get(requestKey);
	}

	clearCache(): void {
		this.cache.clear();
		this.requestCache.clear();
	}
}